import React, { useEffect, useState } from 'react'
import { Breadcrumb, Button, Card, Col, Flex, Row, Space, Table, Tag, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { TableLoader } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';

const { Text } = Typography
const SingleViewPro = () => {
    let { proId } = useParams()
    const navigate = useNavigate() 
    const [ profDetails, setProfDetails] = useState(null);
    const [ loading, setLoading ] = useState(false)
    const ProfDetailView = async () => {
        setLoading(true)
        const result = await apiCalls?.ProfPostApi?.ProfDetailView(proId);
        if (result) {
            setProfDetails(result);
        }
        setLoading(false)
    };

    useEffect(() => {
        ProfDetailView();
    }, [proId]);

    const columns = [
        {
            title: 'Title',
            dataIndex: 'title',
            width: 150,
        },
        {
            title: 'Detail',
            dataIndex: 'detail',
            width: 150,
        },
    ];
    const data = [
        {
            key: '1',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Full Name</Text>
                <Text>
                    {
                        profDetails ?
                        <>
                            {profDetails?.personalData?.firstName?.charAt(0).toUpperCase() + profDetails?.personalData?.firstName?.slice(1)} {' '}
                            {profDetails?.personalData?.lastName?.charAt(0).toUpperCase() + profDetails?.personalData?.lastName?.slice(1)}
                        </>
                        :
                        null
                    }
                </Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Business Name</Text>
                <Text>{profDetails?.personalData?.businessName}</Text>
            </Space>,
        },
        {
            key: '2',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Email</Text>
                <Text>{profDetails?.personalData?.email}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Contact Number</Text>
                <Text>{profDetails?.personalData?.phoneNo}</Text>
            </Space>,
        },
        {
            key: '3',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Role</Text>
                {
                    profDetails?.personalData?.role === "2" ? (
                        <Text className='badge-cs active fs-12'>Professional</Text>
                    ) : profDetails?.personalData?.role === "3" ? (
                        <Text className='badge-cs active fs-12'>Client</Text>
                    ) : null
                }
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Age</Text>
                <Text>{profDetails?.personalData?.age}</Text>
            </Space>,
        },
        {
            key: '4',            
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Salary</Text>
                <Text>{profDetails?.personalData?.salary}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Rating</Text>
                {
                    (()=>{
                        if(profDetails?.rate === 1){
                            return(
                                <Space size={2}>
                                <img src='/assets/icons/star-f.png' width={15} />
                                <img src='/assets/icons/star-e.png' width={15} />
                                <img src='/assets/icons/star-e.png' width={15} />
                                <img src='/assets/icons/star-e.png' width={15} />
                                <img src='/assets/icons/star-e.png' width={15} />
                            </Space>
                            );
                        } else if(profDetails?.rate === 2){
                            return(
                                <Space size={2}>
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                </Space>
                            )
                        } else if(profDetails?.rate === 3){
                            return(
                                <Space size={2}>
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                </Space>
                            )
                        } else if(profDetails?.rate === 4){
                            return(
                                <Space size={2}>
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                </Space>
                            )
                        } else {
                            return (
                                <Space size={2}>
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                </Space>
                            )
                        } 
                    })()}                
            </Space>,
        },
        {
            key: '5',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Emergency Number</Text>
                <Text>{profDetails?.personalData?.emergencyContact}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Insurance</Text>
                <Text>{profDetails?.personalData?.insurance}</Text>
            </Space>,
        },
        {
            key: '6',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Street</Text>
                <Text>{profDetails?.personalData?.street}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>City</Text>
                <Text>{profDetails?.personalData?.city}</Text>
            </Space>,
        },
        {
            key: '7',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Worker Experience</Text>
                <Text>{profDetails?.businessDetail?.exp} Year{ profDetails?.businessDetail?.exp > 1 ? 's' : ''}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Skills/Services</Text>
                <Flex gap={5} wrap>
                    {
                        profDetails?.services?.map((data)=>
                            <Tag className='brand-text border-brand'>
                                {data?.name}
                            </Tag>
                        )
                    }
                </Flex>
            </Space>,
        },
        {
            key: '8',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Registered Date</Text>
                <Text>
                    {profDetails?.personalData?.date}
                </Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Status</Text>
                {
                    profDetails?.personalData?.status === 1 ? (
                        <Text className='badge-cs active fs-12'>Active</Text>
                    ) : (
                        <Text className='badge-cs inactive fs-12'>Inactive</Text>
                    )
                }
            </Space>,
        },
        
        {
            key: '9',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Address</Text>
                <Text>{profDetails?.personalData?.street}</Text>
            </Space>,
        },
    ];

    return (
        <div>
            <Breadcrumb className='mb-3'
                separator=">"
                items={[
                    {
                      title: <Text className='cursor text-gray' onClick={()=>navigate('/professional')}>Professional</Text>,
                    },
                    {
                      title: <Text className='fw-500'>
                        {
                            profDetails ?
                            <>
                                {profDetails?.personalData?.firstName?.charAt(0).toUpperCase() + profDetails?.personalData?.firstName?.slice(1)}{' '}
                                {profDetails?.personalData?.lastName?.charAt(0).toUpperCase() + profDetails?.personalData?.lastName?.slice(1)}
                            </>
                            :
                            null
                        }
                      </Text>,
                    },
                ]}
            />
            <Card className='shadow-d radius-12 mb-3'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Space>
                            <Button className='border0 p-0 bg-transparent' onClick={()=>navigate('/professional')}>
                                <ArrowLeftOutlined />
                            </Button>
                            {
                                profDetails ? 
                                <>
                                    <Text className='fw-500'>
                                        {profDetails?.personalData?.firstName?.charAt(0).toUpperCase() + profDetails?.personalData?.firstName?.slice(1)}{' '}
                                        {profDetails?.personalData?.lastName?.charAt(0).toUpperCase() + profDetails?.personalData?.lastName?.slice(1)}
                                    </Text>
                                    {
                                        profDetails?.personalData?.status === 1 ? (
                                            <Text className='badge-cs active fs-12'>Active</Text>
                                        ) : (
                                            <Text className='badge-cs inactive fs-12'>Inactive</Text>
                                        )
                                    }
                                </>
                                :null
                            }
                        </Space>
                    </Col>  
                    <Col span={24}>
                        <Table 
                            size='large'
                            columns={columns} 
                            dataSource={data} 
                            scroll={{x: 1000}}
                            className='pagination'
                            showSorterTooltip={false}
                            rowHoverable={false}
                            showHeader={false}
                            pagination={false}
                            loading={
                                {
                                    ...TableLoader,
                                    spinning: loading
                                }
                            }
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export { SingleViewPro }
